import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import img1 from "../assets/img/home/trendingAtCutis/trending01.jpg";
import img2 from "../assets/img/home/trendingAtCutis/trending02.jpg";
import img3 from "../assets/img/home/trendingAtCutis/trending-at-cutis-03.jpg";
import img4 from "../assets/img/home/trendingAtCutis/oxyhydrafacial.jpg";
import img5 from "../assets/img/home/trendingAtCutis/cosmelan-peel.jpeg";
const Trending = () => {
  const treandingCutis = [
    {
      id: 1,
      heading: "Laser Hair Reduction",
      content:
        "CACS is the only center with all four types of laser technology like IPL, Alexandrite, Nd:YAG and Diode laser systems, capable of treating any type of hair with different skin types.",
      link: "/service/laser-hair-reduction",
      images: `${img1}`,
      alt: "glowing skin",
    },
    {
      id: 2,
      heading: "Acne Scar Revision",
      content:
        "Acne scars are devastating as they cause anxiety and reduce self-esteem. Cutis provides various treatments like Minimally invasive and Invasive procedure",
      link: "/service/skin-surgery/acne-scar-surgery",
      images: `${img2}`,
      alt: "acne scar treatment",
    },
    {
      id: 3,
      heading: "Skin Radiance",
      content:
        "We let you change your lifestyle by achieving flawless glowing skin and improve your skin tone through unique, effective treatments available only at Cutis.",
      link: "/service/aesthetics/skin-radiance",
      images: `${img3}`,
      alt: "skin treatment",
    },
    {
      id: 4,
      heading: "Oxy Hydrafacial",
      content:
        "Oxy facial is 45 minutes to 1-hour procedure with no downtime allowing one to carry on with your daily activities. An immediate freshness of the face can be seen soon after the treatment, lasting about 15 days.",
      link: "/service/aesthetics/oxy-hydrafacial",
      images: `${img4}`,
      alt: "oxyhydrafacial",
    },
    {
      id: 5,
      heading: " Cosmelan Peel",
      content:
        "Cosmelan peel is the world’s leading professional depigmentation method designed to treat pigmentation, dark spots on your skin, while unifying the skin tone and enhancing skin luminosity.",
      link: "/service/aesthetics/cosmelan-peel",
      images: `${img5}`,
      alt: "cosmelan-peel",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cseEase: "linear",
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    swipeToSlide: true,
  };
  return (
    <>
      <div
        className="container my-3 my-sm-5"
        id="trending_services_home"
        data-aos="fade-up"
      >
        <div className="need-heading">
          <h2 className="text-center text-til my-3">TRENDING AT CUTIS</h2>
        </div>
        <Slider {...settings}>
          {treandingCutis.map((value, index) => (
            <div className="row mx-2" key={index} data-aos="fade-up">
              <div className="col-12">
                <div className="row justify-content-center align-items-center">
                  <div className="col-md-6 order-2 order-md-1 text-center">
                    <h2 className="treandingCutis-heading">
                      <strong>{value.heading}</strong>
                    </h2>
                    <p className="mb-3">{value.content}</p>
                    <Link
                      className="trending-button"
                      to={value.link}
                      target="_blank"
                    >
                      Know More
                    </Link>
                  </div>
                  <div className="col-md-6 order-1 order-md-2 text-center">
                    <img src={value.images} alt="" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};
export default Trending;
